import _ from "lodash";
import React from "react";

export const BOOLEAN_DROPDOWN_OPTIONS = [
    {value: true, label: "true"},
    {value: false, label: "false"}
]

export const YES_NO_DROPDOWN_OPTIONS = [
    { value: 1, label: "Yes" },
    { value: 0, label: "No" }
]

export const getCellForService = (value, dropdownValues) => {
    const displayValue = _.find(dropdownValues, {value: value})
    return <div>{displayValue?.label || value}</div>
};

export const getFilterValueForService = (row, columnIds, filterValue, dropdownValues) => {
    const recordValue = row.original[columnIds];
    const label = _.find(dropdownValues, {value: recordValue})?.label
    return !filterValue || Boolean(`${recordValue} ${label?.toLowerCase()}`.includes(filterValue.toLowerCase()));
};
